import * as Sentry from "@sentry/nextjs";

const isDev = process.env.NODE_ENV === "development";

export function debugLog(category: string, message: string, data?: Record<string, any>) {
  if (isDev) {
    console.log(`[${category}] ${message}`, data ?? "");
  }
  Sentry.addBreadcrumb({
    category,
    message,
    data,
    level: "info",
  });
}